/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AccessRight } from './AccessRight';
import {
    AccessRightFromJSON,
    AccessRightFromJSONTyped,
    AccessRightToJSON,
} from './AccessRight';
import type { ReceiveFilter } from './ReceiveFilter';
import {
    ReceiveFilterFromJSON,
    ReceiveFilterFromJSONTyped,
    ReceiveFilterToJSON,
} from './ReceiveFilter';
import type { TransmitFilter } from './TransmitFilter';
import {
    TransmitFilterFromJSON,
    TransmitFilterFromJSONTyped,
    TransmitFilterToJSON,
} from './TransmitFilter';
import type { UserGroupUid } from './UserGroupUid';
import {
    UserGroupUidFromJSON,
    UserGroupUidFromJSONTyped,
    UserGroupUidToJSON,
} from './UserGroupUid';
import type { UserSetting } from './UserSetting';
import {
    UserSettingFromJSON,
    UserSettingFromJSONTyped,
    UserSettingToJSON,
} from './UserSetting';

/**
 * 
 * @export
 * @interface User
 */
export interface User {
    /**
     * The name of the user
     * @type {string}
     * @memberof User
     */
    name: string;
    /**
     * The UID of the primary group the user is associated with
     * @type {string}
     * @memberof User
     */
    primaryGroup: string;
    /**
     * Full (common) name of the user
     * @type {string}
     * @memberof User
     */
    commonName?: string;
    /**
     * Description of the user
     * @type {string}
     * @memberof User
     */
    description?: string;
    /**
     * Email address of the user
     * @type {string}
     * @memberof User
     */
    email?: string;
    /**
     * Phone number of the user
     * @type {string}
     * @memberof User
     */
    phone?: string;
    /**
     * List of UIDs of groups to which the user belongs
     * @type {Array<UserGroupUid>}
     * @memberof User
     */
    groups?: Array<UserGroupUid>;
    /**
     * Password of the user. Can only be set, not read.
     * @type {string}
     * @memberof User
     */
    password?: string;
    /**
     * Determines if the account is disabled.
     * @type {boolean}
     * @memberof User
     */
    disabled?: boolean;
    /**
     * List of direct TCP access client IP addresses. Allow direct TCP access if non-empty.
     * @type {Array<string>}
     * @memberof User
     */
    directAccess?: Array<string>;
    /**
     * 
     * @type {ReceiveFilter}
     * @memberof User
     */
    receiveFilter?: ReceiveFilter;
    /**
     * 
     * @type {TransmitFilter}
     * @memberof User
     */
    transmitFilter?: TransmitFilter;
    /**
     * The user's private access rights.
     * @type {Array<AccessRight>}
     * @memberof User
     */
    accessRights?: Array<AccessRight>;
    /**
     * The user's private settings.
     * @type {Array<UserSetting>}
     * @memberof User
     */
    settings?: Array<UserSetting>;
}

/**
 * Check if a given object implements the User interface.
 */
export function instanceOfUser(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "primaryGroup" in value;

    return isInstance;
}

export function UserFromJSON(json: any): User {
    return UserFromJSONTyped(json, false);
}

export function UserFromJSONTyped(json: any, ignoreDiscriminator: boolean): User {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'primaryGroup': json['primary_group'],
        'commonName': !exists(json, 'common_name') ? undefined : json['common_name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'groups': !exists(json, 'groups') ? undefined : ((json['groups'] as Array<any>).map(UserGroupUidFromJSON)),
        'password': !exists(json, 'password') ? undefined : json['password'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
        'directAccess': !exists(json, 'direct_access') ? undefined : json['direct_access'],
        'receiveFilter': !exists(json, 'receive_filter') ? undefined : ReceiveFilterFromJSON(json['receive_filter']),
        'transmitFilter': !exists(json, 'transmit_filter') ? undefined : TransmitFilterFromJSON(json['transmit_filter']),
        'accessRights': !exists(json, 'access_rights') ? undefined : ((json['access_rights'] as Array<any>).map(AccessRightFromJSON)),
        'settings': !exists(json, 'settings') ? undefined : ((json['settings'] as Array<any>).map(UserSettingFromJSON)),
    };
}

export function UserToJSON(value?: User | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'primary_group': value.primaryGroup,
        'common_name': value.commonName,
        'description': value.description,
        'email': value.email,
        'phone': value.phone,
        'groups': value.groups === undefined ? undefined : ((value.groups as Array<any>).map(UserGroupUidToJSON)),
        'password': value.password,
        'disabled': value.disabled,
        'direct_access': value.directAccess,
        'receive_filter': ReceiveFilterToJSON(value.receiveFilter),
        'transmit_filter': TransmitFilterToJSON(value.transmitFilter),
        'access_rights': value.accessRights === undefined ? undefined : ((value.accessRights as Array<any>).map(AccessRightToJSON)),
        'settings': value.settings === undefined ? undefined : ((value.settings as Array<any>).map(UserSettingToJSON)),
    };
}

